//#region src/components/Banner/Banner.module.css
var e = "_critical_t6ckf_1", t = "_moderate_t6ckf_7", n = "_info_t6ckf_13", r = "_banner_t6ckf_19", i = "_text_t6ckf_30", a = "_closeButton_t6ckf_34", o = "_closeIcon_t6ckf_39", s = "_actionButton_t6ckf_47", c = "_bannerWithActions_t6ckf_52", l = "_absoluteIcon_t6ckf_56", u = {
	critical: e,
	moderate: t,
	info: n,
	banner: r,
	text: i,
	closeButton: a,
	closeIcon: o,
	actionButton: s,
	bannerWithActions: c,
	absoluteIcon: l
};
//#endregion
export { l as absoluteIcon, s as actionButton, r as banner, c as bannerWithActions, a as closeButton, o as closeIcon, e as critical, u as default, n as info, t as moderate, i as text };
